const DEFAULT_LANGUAGE = 'sv';

const getTranslatedProperty = (iso: string, key: string, object: Record<any, any>) => {
    if (!key || !object || Object.keys(object).length === 0) return '';

    const value = object[key]?.[iso] ?? object[key]?.[DEFAULT_LANGUAGE] ?? '';

    // Handle double-nested translation objects: { sv: { sv: "...", en: "..." } }
    if (value && typeof value === 'object') {
        return value[iso] ?? value[DEFAULT_LANGUAGE] ?? '';
    }

    return value;
};

export { getTranslatedProperty };